export enum PERMISSION_ROLE_KEYS {
  ROLE_EXTERNAL = 'ROL_EXTERNOS',
}
